import { render } from "./TempSavedImplantsHospital.vue?vue&type=template&id=27040d70&scoped=true"
import script from "./TempSavedImplantsHospital.vue?vue&type=script&lang=js"
export * from "./TempSavedImplantsHospital.vue?vue&type=script&lang=js"

import "./TempSavedImplantsHospital.vue?vue&type=style&index=0&id=27040d70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27040d70"]])

export default __exports__